import React from "react";
import classes from './ServicesTopologiesDocumet.module.scss'
import Document from "../../../../components/Document";
export default function ServicesTopologiesDocumet() {
    return(
        <Document/>

    )
    
}